// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__2N_Fs","pageFull":"styles_pageFull__1CXSY"};